import { SET_FEATURE_FLAGS } from "@constants/action-types";

export const setFeatureFlags = (value) => ({
  type: SET_FEATURE_FLAGS,
  value,
});
